import { useContext } from "react";
import Product from "./Product";
import { contextProvider } from "../Providers";

export default function Products({ products, addToCart }) {
  const { filter } = useContext(contextProvider);
  
  return (
    <div className="items">
      {products.map((product) => {
        if (filter === "") {
          return (
            <Product key={product.id} product={product} addToCart={addToCart} />
          );
        } else {
          if (product.id_categoria === filter)
            return (
              <Product
                key={product.id}
                product={product}
                addToCart={addToCart}
              />
            );
        }
      })}
    </div>
  );
}
